import {s_char_matrices, s_char_matricespells} from "../../_signals/s_char";

export const matriceHasFreeSpace = (matriceId: string, circle: number) => {
    const matrice = s_char_matrices.value.find(m => m.id === matriceId);
    if (!matrice) return false

    const matriceSpells = s_char_matricespells.value.filter(ms => ms.mid === matriceId);

    if (matrice.name === 'Summenmatrix') {
        const matriceSpellsCircles = matriceSpells.reduce((sum, spell) => sum + spell.circle, 0)
        return matrice.rank - matriceSpellsCircles >= circle
    }

    if (matrice.split) {
        const matriceSpellsCircles = matriceSpells.reduce((sum, spell) => sum + spell.circle, 0)
        return matrice.rank - matriceSpellsCircles >= circle
    }

    return matriceSpells.length ===0 && matrice.rank >= circle
}